import React, { useState } from 'react';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Checkbox,
  Box,
  Grid,
  Container,
  CircularProgress
} from "@mui/material";
import { useNavigate } from 'react-router-dom';

const platformsOptions = [
  'Netflix',
  'Amazon Prime Video',
  'Max',
  'Disney Plus',
  'Star Plus',
  'Paramount Plus',
  'Apple TV Plus',
];

const RegisterForm = ({ idToken, user }) => {
  const [firstName, setFirstName] = useState(user.firstName);
  const [lastName, setLastName] = useState(user.lastName);
  const [loading, setLoading] = useState(false);
  const [platforms, setPlatforms] = useState([]);
  const navigate = useNavigate();

  const handleRegister = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbxREPDO9_xArVTVk3trXhFg-u76nPzCES2MoIyBtsUPy7xTGYoNRClNu-AMkltdCSZx/exec?action=registeruser`,
        {
          method: "POST",
          body: JSON.stringify({
            id_token: idToken,
            first_name: firstName,
            last_name: lastName,
            platforms: platforms,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.status !== "success") {
        throw new Error("API error");
      }

      setLoading(false);
      navigate('/');

    } catch (error) {
      console.error("Error registering user:", error);
      setLoading(false);
    }
  };

  const handlePlatformChange = (event) => {
    setPlatforms(event.target.value);
  };

  return (
    <Container maxWidth="md" sx={{padding:2}}>
      <form>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              id="email"
              label="Email"
              value={user.email}
              disabled
              fullWidth
              variant="outlined"
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="firstName"
              label="Nombre"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
              disabled={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="lastName"
              label="Apellido"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
              disabled={loading}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" margin="normal" disabled={loading}>
              <InputLabel id="platforms-label">Plataformas disponibles</InputLabel>
              <Select
                labelId="platforms-label"
                id="platforms"
                multiple
                value={platforms}
                onChange={handlePlatformChange}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </Box>
                )}
              >
                {platformsOptions.map((platform) => (
                  <MenuItem key={platform} value={platform}>
                    <Checkbox checked={platforms.indexOf(platform) > -1} />
                    {platform}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleRegister}
              fullWidth
              disabled={loading}
              style={{ borderRadius: '20px', padding: '10px 20px', fontSize: '1rem' }}
            >
              Crear cuenta
            </Button>
          </Grid>
        </Grid>
      </form>
      {loading && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
    </Container>
  );
};

export default RegisterForm;
